<template>
  <div class="inline-block">
    <a-select v-model="pickDay" class="w-150" :disabled="dayOpts.length<1">
      <a-select-option :key="-1" :value="''">
        请选择预约日
      </a-select-option>
      <a-select-option v-for="(i,index) in dayOpts" :key="index" :value="i.code">
        {{ i.name }}
      </a-select-option>
    </a-select>
    <a-select v-model="pickTime" :disabled="timeOpts.length<1" class="w-150">
      <a-select-option :key="-1" :value="''">
        请选择预约时间
      </a-select-option>
      <a-select-option v-for="(i,index) in timeOpts" :key="index" :value="i.code">
        {{ i.name }}
      </a-select-option>
    </a-select>
    <a-button type="primary" class="ml-10" @click="ok">确定</a-button>
    <a-button class="" @click="$emit('cancel')">取消</a-button>
  </div>
</template>
<script>
export default {
  props: {
    shipperCode: {
      type: String,
      default: ''
    },
    orderCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pickDay: '',
      pickTime: '',
      dayOpts: [],
      timeOpts: []
    }
  },
  watch: {
    pickDay(n) {
      if (n) {
        this.onDayChange(n)
      } else {
        this.form.pickTime = ''
      }
    }
  },
  created() {
    this.getTimeOpt(this.shipperCode)
  },
  methods: {
    async ok() {
    //   ok
      const res = await this.$http({ ...this.$api.orderUpdatePickupTime, origin: true }, {
        orderCode: this.orderCode,
        'pickupEndTime': this.pickTime.split('~')[1],
        'pickupStartTime': this.pickTime.split('~')[0]
      })
      if (res.data.state === 'success') {
        this.$emit('success')
      } else {
        this.$message.error(res.data.msg)
      }
    },
    async onDayChange(val) {
      const res = await this.$http(this.$api.orderGetPickupTimeSlot, {
        shipperCode: this.shipperCode,
        shortDay: val
      })
      this.timeOpts = res
      this.pickTime = ''
    },
    async getTimeOpt(shipperCode) {
      const res = await this.$http(this.$api.orderGetPickupDay, {
        shipperCode
      })
      this.dayOpts = res
      this.timeOpts = []
    }
  }
}
</script>
<style lang="scss">

</style>
